// DES2 WS-14: the Knowledge page copy in this language (see ui/i18n/ns/knowledge-pages.ts).
import type { KnowledgePagesCopy } from '../ns/knowledge-pages';

const nl: KnowledgePagesCopy = {
  knowledgePage: 'Kennispagina',
  knowledgePages: 'Kennispagina’s',
  featureOffTitle: 'Kennispagina’s zijn niet ingeschakeld in deze werkruimte.',
  featureOffBody: 'Bedrijfscontext en bronnen staan nog steeds in Kennis.',
  loadingPage: 'Pagina laden…',
  loadingSuggestion: 'Voorstel laden…',
  cancel: 'Annuleren',
  tryAgain: 'Opnieuw proberen',
  everyoneIn: 'Iedereen bij {company}',
  yourCompany: 'je bedrijf',
  revision: 'Revisie {n}',
  openRevision: 'Revisie {n} openen',
  pageCount: 'one:pagina|other:pagina’s',
  topicCount: 'one:onderwerp|other:onderwerpen',
  sectionCount: 'one:sectie|other:secties',
  lineCount: 'one:regel|other:regels',
  documentCount: 'one:document|other:documenten',
  changeCount: 'one:wijziging|other:wijzigingen',
  newPageCount: 'one:nieuwe pagina|other:nieuwe pagina’s',
  changedPageCount: 'one:gewijzigde pagina|other:gewijzigde pagina’s',
  otherSectionCount: 'one:andere sectie|other:andere secties',
  characterCount: 'one:teken|other:tekens',
  diffStats: '{sections} gewijzigd · {added} toegevoegd · {removed} verwijderd',
  diffMatchesBase: 'De voorgestelde tekst komt overeen met de basisrevisie.',
  diffIntroduction: 'Inleiding',
  diffOtherUnchanged: '{sections} ongewijzigd.',
  timeJustNow: 'zojuist',
  originImportedFrom: 'Geïmporteerd uit {path}',
  originImportedFromCommit: 'Geïmporteerd uit {path} @ {commit}',
  authorityApprovedInPoneva: 'Goedgekeurd in Poneva',
  authorityImported: 'Geïmporteerd',
  authorityInRepository: '{canonicality} in de repository',
  authorityVerified: 'geverifieerd op {date}',
  authorRepositoryImport: 'Repository-import',
  authorSuggestedInChat: 'Voorgesteld in de chat',
  authorSuggestedInChatWith: 'Voorgesteld in de chat met {name}',
  authorSuggestedBy: 'Voorgesteld door {name}',
  authorSuggestedByApp: 'Voorgesteld door een verbonden app',
  authorSuggestedByColleague: 'Voorgesteld door een collega',
  authorSuggestedByYou: 'Voorgesteld door jou',
  authorSuggestedOnBehalf: 'Voorgesteld door {app} namens {name}',
  authorSuggestedByAppOnBehalf: 'Voorgesteld door een verbonden app namens {name}',
  authorSuggestedAndApproved: 'Voorgesteld en goedgekeurd door {name}',
  approverApprovedBy: 'goedgekeurd door {name}',
  approverAppliedBy: 'toegepast door {name}',
  kindCreatePage: 'Nieuwe pagina',
  kindUpdatePage: 'Voorgestelde update',
  kindArchivePage: 'Archivering',
  statusConflict: 'Conflict · pagina gewijzigd',
  statusPending: 'Wacht op beoordeling',
  statusApproved: 'Goedgekeurd',
  statusRejected: 'Afgewezen',
  statusWithdrawn: 'Ingetrokken',
  statusSuperseded: 'Vervangen',
  errRevisionConflict: 'Deze pagina is gewijzigd terwijl je hem beoordeelde.',
  errProposalChanged:
    'Dit voorstel is gewijzigd terwijl je het beoordeelde. Bekijk de nieuwste versie voordat je beslist.',
  errPublishRequired:
    'Alleen publicatiebeheerders van het bedrijf kunnen kenniswijzigingen goedkeuren of pagina’s importeren.',
  errProposalLimit:
    'Je bedrijf heeft al 200 voorstellen die op beoordeling wachten. Beoordeel er eerst een paar voordat je meer voorstelt.',
  errAuthorLimit:
    'Je hebt al 50 voorstellen die op beoordeling wachten. Wacht tot er een paar zijn beslist, of trek er een paar in, voordat je meer voorstelt.',
  errImportProposalLimit:
    'Deze import zou meer gewijzigde pagina’s ter beoordeling toevoegen dan in de beoordelingswachtrij van je bedrijf passen (maximaal 200). Beslis eerst over een paar voorstellen in Ter beoordeling en pas de import dan opnieuw toe.',
  errImportChanged:
    'Dit is niet de import die je hebt beoordeeld. Open hem opnieuw en beoordeel hem voordat je hem toepast.',
  errImportItemNotFound: 'Dit document maakt geen deel meer uit van de import.',
  errIdempotencyConflict:
    'Dit voorstel is al met andere inhoud verstuurd. Laad opnieuw en probeer het nog eens.',
  errImportHashMismatch:
    'Een bestand in deze snapshot komt niet overeen met de vastgelegde checksum. Maak de snapshot opnieuw en probeer het nog eens.',
  errImportAlreadyApplied: 'Deze import is al toegepast.',
  errImportDiscarded: 'Deze import is verwijderd. Kies het snapshotbestand opnieuw.',
  errImportDuplicateItem:
    'Deze snapshot bevat hetzelfde document twee keer. Maak de snapshot opnieuw.',
  errInvalidImport:
    'Poneva kan deze snapshot niet accepteren. Maak hem opnieuw met het snapshotscript en probeer het nog eens.',
  errInvalidInput:
    'Poneva kan deze invoer niet accepteren. Controleer de velden en probeer het opnieuw.',
  errImportLimit:
    'Er staan te veel imports klaar die nog niet zijn toegepast. Pas er een paar toe of verwijder ze voordat je een nieuwe klaarzet.',
  errPageTooLarge: 'Een pagina is groter dan 256 KB. Splits hem op in kleinere pagina’s.',
  errTooManySections: 'Een pagina heeft meer dan 2.000 koppen. Splits hem op in kleinere pagina’s.',
  errPageLimit: 'Je bedrijf heeft de limiet van 2.000 kennispagina’s bereikt.',
  errCollectionLimit: 'Je bedrijf heeft de limiet van 100 onderwerpen bereikt.',
  errProposalNotPending: 'Over dit voorstel is al beslist. De getoonde status is actueel.',
  errRequesterRemoved:
    'De persoon die dit heeft voorgesteld, maakt geen deel meer uit van dit bedrijf. Daarom kan het niet worden goedgekeurd.',
  errRevisionAlreadyCurrent: 'Die revisie is al de huidige.',
  errPageArchived:
    'Deze pagina is gearchiveerd terwijl je hem beoordeelde. Beoordeel het voorstel opnieuw voordat je beslist.',
  errAlreadyArchived: 'Deze pagina is al gearchiveerd.',
  errProposalForbidden: 'Alleen de persoon die dit heeft voorgesteld, kan het intrekken.',
  errUnavailable: 'Kennispagina’s zijn op dit moment niet beschikbaar.',
  errTimeout: 'Poneva deed er te lang over om te antwoorden.',
  errItemTooLarge: '{path} is groter dan 256 KB. Splits het op in kleinere pagina’s.',
  errItemTooManySections: '{path} heeft meer dan 2.000 koppen. Splits het op in kleinere pagina’s.',
  errItemHashMismatch:
    '{path} komt niet overeen met de vastgelegde checksum. Maak de snapshot opnieuw en probeer het nog eens.',
  errNoLongerAvailable: 'Dit item is niet meer voor je beschikbaar.',
  errTooLargeToSend: 'Dit bestand is te groot om te versturen.',
  cardChecking: 'Status controleren…',
  cardNotAvailable: 'Niet beschikbaar',
  cardStatusUnavailable: 'Status niet beschikbaar',
  cardUnshowable: 'Deze voorgestelde kennisupdate kan niet worden weergegeven.',
  cardEyebrow: 'Voorgestelde kennisupdate',
  cardLabel: 'Voorgestelde kennisupdate · {title}',
  cardMissing: 'Dit voorstel is niet meer voor je beschikbaar.',
  cardUnknown:
    'We konden niet nagaan hoe het met dit voorstel staat. Open de beoordeling om de status te zien.',
  cardCheckAgain: 'Opnieuw controleren',
  cardReview: 'Update beoordelen',
  statusLineApproved: 'Goedgekeurde kennis',
  readyCount: 'one:klaar voor zoeken|other:klaar voor zoeken',
  preparingCount: 'one:wordt voorbereid|other:worden voorbereid',
  attentionCount: 'one:vraagt aandacht|other:vragen aandacht',
  topicsExplore: 'Een onderwerp verkennen',
  topicsAllPages: 'Alle pagina’s',
  topicsOpenPages: 'Pagina’s openen',
  topicsEmpty:
    'Nog geen goedgekeurde pagina’s. Pagina’s bevatten uitgebreide bedrijfskennis met de volledige revisiegeschiedenis.',
  reviewsTitle: 'Voorgestelde pagina-updates',
  reviewsTitleMine: 'Jouw voorgestelde pagina-updates',
  reviewsIntro:
    'Elk voorstel is een volledige kandidaat-revisie met een reden en onderbouwing. Er verandert niets totdat je precies die revisie goedkeurt.',
  reviewsIntroMine:
    'Je voorstellen wachten hier tot een publicatiebeheerder van het bedrijf ze beoordeelt. Tot dan blijven de pagina’s zoals ze zijn.',
  loadPagesFailed: 'We konden de kennispagina’s niet laden.',
  loadProposalsFailed: 'We konden de voorgestelde pagina-updates niet laden.',
  loadMoreFailed: 'We konden geen pagina’s meer laden.',
  otherPages: 'Andere pagina’s',
  loadTopicFailed: 'We konden dit onderwerp niet laden.',
  revisionShort: 'r{n}',
  updatedOn: 'Bijgewerkt op {date}',
  emptyTitle: 'Nog geen kennispagina’s.',
  emptyBody:
    'Pagina’s bevatten de goedgekeurde, uitgebreide kennis van je bedrijf — richting, besluiten en werkwijzen — waarbij elke revisie bewaard blijft. Importeer vanuit een repository-snapshot of begin een pagina in de chat; een publicatiebeheerder keurt elke pagina goed voordat die als bedrijfskennis telt.',
  importFromSnapshot: 'Importeren vanuit een repository-snapshot',
  startInChat: 'Een pagina beginnen in de chat',
  startInChatPrompt:
    'Help me een kennispagina voor ons bedrijf te beginnen. Vraag wat erin moet komen en verzin geen inhoud. Het blijft een voorstel tot een publicatiebeheerder van het bedrijf het goedkeurt.',
  loadingPages: 'Kennispagina’s laden…',
  filterLabel: 'Pagina’s filteren op titel',
  filterPlaceholder: 'Pagina’s filteren',
  importButton: 'Importeren',
  showingTopic: '{topic} wordt getoond',
  showAllTopics: 'Alle onderwerpen tonen',
  loadingTopic: 'Dit onderwerp laden…',
  noMatch: 'Geen pagina’s gevonden voor ‘{filter}’.',
  topicNoPages: 'Nog geen goedgekeurde pagina’s in dit onderwerp.',
  loading: 'Laden…',
  loadMore: 'Meer pagina’s laden',
  metaApproved: 'goedgekeurd op {date}',
  metaRepositoryAuthoritative: 'repository blijft leidend',
  loadPageFailed: 'We konden deze pagina niet laden.',
  loadHistoryFailed: 'We konden de revisiegeschiedenis niet laden.',
  outlineLabel: 'Paginasecties',
  outlineToggle: 'Op deze pagina',
  loadingHistory: 'Revisiegeschiedenis laden…',
  historyLabel: 'Revisiegeschiedenis',
  historyIntro:
    'Elke goedgekeurde revisie blijft bewaard. Een eerdere revisie terugzetten maakt een voorstel ter beoordeling aan; latere revisies worden nooit gewist.',
  historyCurrent: 'Huidig',
  historyViewing: 'Wordt bekeken',
  historyView: 'Bekijken',
  historyViewAria: 'Revisie {n} bekijken',
  restoreAria: 'Terugzetten als voorstel: revisie {n}',
  restoreCreating: 'Voorstel aanmaken…',
  restore: 'Terugzetten als voorstel',
  restoreUnconfirmed:
    'We konden niet bevestigen dat het voorstel is aangemaakt. Kijk in Ter beoordeling voordat je het opnieuw probeert.',
  editTooLarge:
    'Deze pagina is groter dan 256 KB. Splits hem op in kleinere pagina’s voordat je hem voorstelt.',
  editConflict:
    'Deze pagina is gewijzigd terwijl je aan het bewerken was. Kopieer je tekst, open de nieuwste revisie en stel de bewerking opnieuw voor.',
  editUnconfirmed:
    'We konden niet bevestigen dat je voorstel is verstuurd. Kijk in Ter beoordeling voordat je het opnieuw verstuurt.',
  editHeading: 'Een bewerking voorstellen',
  editIntro:
    'Je bewerkt revisie {n}. Een publicatiebeheerder van het bedrijf beoordeelt de exacte wijziging voordat die revisie {next} wordt; tot dan blijft de pagina zoals ze is.',
  editOutdated:
    'Er is een nieuwere revisie goedgekeurd terwijl je aan het bewerken was. Kopieer je tekst en begin opnieuw vanaf de nieuwste revisie, zodat niets van wat daarin is gewijzigd verloren gaat.',
  editContentLabel: 'Pagina-inhoud (Markdown)',
  editReasonLabel: 'Waarom deze wijziging?',
  editReasonPlaceholder: 'Wat is er gewijzigd, en waar komt het vandaan?',
  editSending: 'Versturen…',
  editSend: 'Ter beoordeling versturen',
  editDiscardConfirm: 'Deze bewerking verwijderen? Niets van wat je hebt gewijzigd, is verstuurd.',
  editNoChanges: 'Nog geen wijzigingen.',
  editNeedsContent: 'Een pagina heeft inhoud nodig.',
  exportFailed: 'We konden deze pagina niet exporteren. Probeer het opnieuw.',
  askPagePrompt: 'Vraag over de kennispagina ‘{title}’ (revisie {n}, {link}):',
  askPageSectionPrompt: 'Vraag over de kennispagina ‘{title}’ § {section} (revisie {n}, {link}):',
  pageMissingTitle: 'Deze pagina is niet beschikbaar.',
  pageMissingBody:
    'Misschien is hij gearchiveerd, of heb je geen toegang meer tot de kennis van dit bedrijf.',
  pageArchived: 'Gearchiveerd',
  viewingRevisionCurrent: 'Je bekijkt revisie {n}; de huidige revisie is {current}.',
  viewingRevisionOld: 'Je bekijkt revisie {n}. Dit is niet de huidige revisie.',
  openCurrent: 'Huidige openen',
  archivedBanner:
    'Deze pagina is gearchiveerd. Ze wordt niet meer gebruikt voor antwoorden; de geschiedenis blijft bewaard.',
  pageViewsLabel: 'Paginaweergaven',
  tabRead: 'Lezen',
  tabHistory: 'Geschiedenis',
  unknownSection:
    'De gekoppelde sectie maakt geen deel uit van deze revisie. De hele pagina wordt getoond.',
  askAboutPage: 'Vragen over deze pagina',
  exporting: 'Exporteren…',
  exportMarkdown: 'Markdown exporteren',
  loadSuggestionFailed: 'We konden dit voorstel niet laden.',
  evidenceSource: 'Bron',
  evidenceFact: 'Bedrijfscontext',
  evidenceResult: 'Opgeslagen werk',
  evidenceUrl: 'Webpagina',
  evidenceDecision: 'Besluit',
  evidenceReference: 'Referentie',
  evidenceOpenPage: 'Kennispagina openen',
  evidenceOpenSource: 'Bron openen',
  evidenceOpenFact: 'Bedrijfscontext openen',
  evidenceOpenResult: 'Opgeslagen werk openen',
  evidenceOpenUrl: 'Webpagina openen',
  evidenceOpenDecision: 'Besluit openen',
  evidenceOpenReference: 'Referentie openen',
  evidenceDecisionNote: 'Een vastgelegd besluit. Er is niets om te openen in Poneva.',
  evidenceFactGone: 'Deze bedrijfscontext is niet meer opgeslagen.',
  evidencePageNoRevision: 'Deze pagina heeft geen goedgekeurde revisie om te openen.',
  evidencePrivateExcerpt: 'Privéonderbouwing — alleen het fragment hierboven is gedeeld.',
  evidencePrivate: 'Privéonderbouwing — de inhoud is niet met je gedeeld.',
  evidenceHeading: 'Onderbouwing',
  evidenceNone: 'Er is geen onderbouwing toegevoegd. Beoordeel de reden hierboven op zichzelf.',
  changeAdded: 'Toegevoegd',
  changeRemoved: 'Verwijderd',
  changeChanged: 'Gewijzigd',
  changeUnchanged: 'Ongewijzigd',
  moreLineCount: 'one:regel meer|other:regels meer',
  moreUnchangedLineCount: 'one:ongewijzigde regel meer|other:ongewijzigde regels meer',
  unchangedLineCount: 'one:ongewijzigde regel|other:ongewijzigde regels',
  skipAdded: '{lines} — te zien in de volledige revisie',
  skipRemoved: '{lines} verwijderd',
  cutUnchanged: '{lines} niet getoond',
  cutChanged: '{lines} niet getoond, {changes}. Bekijk ze in de volledige revisie.',
  cutAddedRemoved: '{added} toegevoegd en {removed} verwijderd',
  cutAdded: '{added} toegevoegd',
  cutRemoved: '{removed} verwijderd',
  lineAddedSr: 'Toegevoegd:',
  lineRemovedSr: 'Verwijderd:',
  noLinesAdded: 'Een nieuwe sectie. De tekst staat in de volledige revisie hieronder.',
  noLinesRemoved: 'Deze sectie zou van de pagina worden verwijderd.',
  noLinesChanged: 'Deze sectie verandert. De tekst staat in de volledige revisie hieronder.',
  diffHeading: 'Wijzigingen',
  outcomeArchived: 'Gearchiveerd.',
  outcomeArchivedBody:
    '{title} wordt niet meer gebruikt voor antwoorden en staat niet meer in de paginalijst. De revisies, dit voorstel en het besluit blijven in de paginageschiedenis.',
  openArchivedPage: 'Gearchiveerde pagina openen',
  outcomeApproved: 'Goedgekeurd.',
  outcomeApprovedRevision: 'Revisie {n} is nu de goedgekeurde versie van {title}.',
  outcomeApprovedPlain: 'Dit voorstel is goedgekeurd.',
  outcomeRestored: 'De pagina staat weer in de paginalijst en wordt weer gebruikt voor antwoorden.',
  outcomeKept:
    'Het voorstel, het besluit en elke eerdere revisie blijven in de paginageschiedenis.',
  openPage: 'Pagina openen',
  outcomeDismissed: 'Afgewezen.',
  outcomeWithdrawn: 'Ingetrokken.',
  outcomeSuperseded: 'Vervangen.',
  outcomeSupersededBody:
    'Een nieuwere revisie, een nieuwer voorstel of een repository-import heeft dit voorstel achterhaald. Het heeft zelf niets gewijzigd.',
  outcomeUnchanged: 'De pagina blijft zoals ze is.',
  approveNewPage: 'Nieuwe pagina goedkeuren',
  approveArchive: 'Archivering goedkeuren',
  approveRestoreRevision: 'Revisie {n} terugzetten en goedkeuren',
  approveRevision: 'Revisie {n} goedkeuren',
  approveArchiveNote: 'Bij goedkeuring wordt deze pagina gearchiveerd voor iedereen bij {company}.',
  approvePublishNote:
    'Bij goedkeuring wordt deze revisie gepubliceerd voor iedereen bij {company}.',
  approvePublishEvidenceNote:
    'Bij goedkeuring worden deze revisie en de fragmenten uit de onderbouwing hierboven gepubliceerd voor iedereen bij {company}.',
  archivedTitle: 'Deze pagina is gearchiveerd.',
  alreadyArchivedBody:
    'Goedkeuren zou niets veranderen, dus dit voorstel kan alleen worden afgewezen.',
  archivedRestoreBody:
    'Bij goedkeuring wordt de pagina hersteld: ze komt met deze revisie terug in de paginalijst, de zoekresultaten en antwoorden.',
  staleRevisionAction: 'Vergelijken met de nieuwste versie',
  staleProposalTitle: 'Dit voorstel is gewijzigd terwijl je het beoordeelde.',
  staleProposalAction: 'De nieuwste versie beoordelen',
  staleArchivedTitle:
    'Deze pagina is gearchiveerd terwijl je hem beoordeelde. Als je dit voorstel goedkeurt, komt hij terug.',
  staleArchivedAction: 'Opnieuw beoordelen',
  suggestionMissingTitle: 'Dit voorstel is niet beschikbaar.',
  suggestionMissingBody:
    'Misschien is het ingetrokken, of het is van iemand anders en nog niet ter beoordeling naar het bedrijf verstuurd.',
  decideUnconfirmed:
    'We konden je besluit niet bevestigen. De getoonde status is de nieuwste van Poneva; controleer die voordat je het opnieuw probeert.',
  decideFailed: 'We konden je besluit niet opslaan.',
  discussPrompt: 'Help me de voorgestelde kennisupdate van ‘{title}’ ({link}) te verbeteren.',
  conflictBody:
    'Dit voorstel is geschreven op basis van revisie {base}; de huidige revisie is {current}. Goedkeuren zou die wijziging overschrijven, dus het kan in deze vorm niet worden goedgekeurd.',
  conflictBodyPlain:
    'Dit voorstel is geschreven op basis van een eerdere revisie, dus het kan in deze vorm niet worden goedgekeurd.',
  openLatest: 'Nieuwste versie openen',
  reworkInChat: 'Herwerken in de chat',
  factReason: 'Reden',
  factNoReason: 'Er is geen reden opgegeven.',
  factAudience: 'Doelgroep',
  factRevision: 'Revisie',
  revisionNew: 'Een nieuwe pagina, revisie 1',
  revisionArchiveAfter: 'Archiveren na revisie {n}',
  revisionWrittenAgainst: 'Geschreven op basis van revisie {base}; de huidige revisie is {current}',
  revisionCurrentToProposed: 'Huidige revisie {base} → voorgestelde revisie {next}',
  revisionProposed: 'Voorgestelde revisie {next}',
  proposedPage: 'Voorgestelde pagina',
  archivingHeading: 'Wat archiveren doet',
  archivingBody:
    'De pagina wordt niet meer gebruikt voor antwoorden en verdwijnt uit de paginalijst. De revisies en dit besluit blijven bewaard.',
  noComparison: 'Voor dit voorstel is geen vergelijking per sectie beschikbaar.',
  showComplete: 'Volledige revisie tonen',
  approving: 'Goedkeuren…',
  dismissing: 'Afwijzen…',
  dismiss: 'Afwijzen',
  withdrawing: 'Intrekken…',
  withdraw: 'Intrekken',
  editInChat: 'Bewerken in de chat',
  waitingForPublisher: 'Wacht op beoordeling door een publicatiebeheerder van het bedrijf.',
  snapshotTooLarge: 'Deze snapshot is groter dan 8 MB. Maak hem met minder documenten.',
  snapshotNotSnapshot:
    'Dit bestand is geen kennissnapshot. Kies het JSON-bestand dat het snapshotscript heeft gemaakt.',
  snapshotEmpty: 'Deze snapshot bevat geen documenten.',
  readDocumentFailed: 'We konden dit document niet lezen. Probeer het opnieuw.',
  readingDocument: 'Document lezen…',
  hideText: 'Tekst verbergen',
  readText: 'Tekst lezen',
  textOf: 'Tekst van {title}',
  gitSnapshot: 'Git-snapshot {commit}',
  repositorySnapshot: 'Repository-snapshot',
  importNewHeading: '{pages} · goedgekeurd zodra je toepast',
  importNewNote:
    'Elke pagina wordt zonder verdere beoordeling gepubliceerd als goedgekeurde pagina voor iedereen bij {company}. Lees ze allemaal voordat je toepast.',
  importChangedHeading: '{pages} · ter beoordeling verstuurd',
  importChangedNote:
    'Elk document wordt een voorgestelde update. De pagina verandert pas wanneer een publicatiebeheerder het goedkeurt in Ter beoordeling, waar te zien is wat er is gewijzigd.',
  unchangedDocumentCount: 'one:ongewijzigd document|other:ongewijzigde documenten',
  unchangedNote:
    'Deze komen al overeen met hun goedgekeurde pagina’s. Er wordt niets voor geschreven.',
  stagedHeading: 'Klaargezet maar niet toegepast',
  excludedSummary: '{documents} niet opgenomen in deze snapshot',
  countsLine: '{newPages} · {changedPages} ter beoordeling · {unchanged} ongewijzigd',
  importAlreadyDiscarded: 'Deze import is al verwijderd.',
  confirmLabel: 'Import bevestigen',
  unchangedKeepCount:
    'one:ongewijzigd document behoudt zijn pagina|other:ongewijzigde documenten behouden hun pagina’s',
  confirmBody:
    'Deze import toepassen voor iedereen bij {company}? {newPages} worden goedgekeurd als revisie 1, {changedPages} wachten op beoordeling, en {unchanged}. Eerdere importvoorstellen voor deze pagina’s worden ingetrokken.',
  applying: 'Toepassen…',
  applyImport: 'Import toepassen',
  chooseAnother: 'Ander bestand kiezen',
  allCurrent: 'Alles in deze snapshot is al actueel.',
  importApplied: 'Import toegepast.',
  appliedSummary:
    '{pages} aangemaakt · {changes} wachten op beoordeling · {unchanged} ongewijzigd.',
  appliedIndexing:
    'Nieuwe pagina’s zijn doorzoekbaar in de chat zodra het indexeren klaar is. Bij Bronvoorbereiding zie je de voortgang.',
  openPages: 'Pagina’s openen',
  reviewChanges: '{changes} beoordelen',
  checkIndexing: 'Voortgang van het indexeren bekijken',
  sendSnapshotFailed: 'We konden deze snapshot niet versturen. Probeer het opnieuw.',
  openStagedFailed: 'We konden deze klaargezette import niet openen.',
  applyUnconfirmed:
    'We konden niet bevestigen of de import is toegepast. Kijk in Pagina’s voordat je het opnieuw probeert.',
  applyFailed: 'We konden deze import niet toepassen.',
  importHeading: 'Pagina’s importeren uit de repository',
  backToPages: 'Terug naar pagina’s',
  importLead:
    'Maak een snapshot met {command} en kies dan het bestand. Je ziet elk document en wat het zou veranderen voordat er iets wordt opgeslagen.',
  snapshotFileLabel: 'Kennissnapshotbestand',
  readingSnapshot: 'Snapshot lezen…',
  openingStaged: 'Klaargezette import openen…',
  chooseSnapshot: 'Snapshotbestand kiezen',
  factOrigin: 'Herkomst',
  factContents: 'Inhoud',
  importOnlyListed: 'Alleen de documenten die hier staan, worden geïmporteerd.',
  importRepositoryAuthoritative:
    'De repository blijft leidend; gewijzigde documenten worden voorstellen ter beoordeling.',
  overviewReviewChanges: 'Wijzigingen beoordelen',
  overviewConnectAgents: 'Externe agents verbinden',
  overviewEyebrow: 'Een gedeeld beeld',
  overviewTitle: '{company} in beeld.',
  overviewLeadFallback:
    'De kennis van je bedrijf begint bij de context die je deelt. Bouw samen een beeld op van je bedrijf.',
  overviewBody:
    'Bedrijfscontext en bronmateriaal geven Poneva een vertrekpunt — niet alles wat er over {company} te weten valt. Blijf dit beeld aanvullen naarmate je bedrijf zich ontwikkelt.',
  overviewAskPrompt: 'Wat weet je over ons bedrijf, en wat zou nuttig zijn om toe te voegen?',
  overviewAsk: 'Vragen over {company}',
  overviewAddSources: 'Bronnen toevoegen',
  contextEyebrow: 'Wat antwoorden context geeft',
  contextTitle: 'Het bedrijf achter de vraag.',
  contextBody:
    'Websitebronnen leggen het publieke bedrijf uit. Bedrijfsnotities voegen je terminologie, prioriteiten en werkwijze toe.',
  contextPrompt:
    'Help me de bedrijfsprioriteiten en werkvoorkeuren te verduidelijken die we moeten onthouden.',
  contextAction: 'Ons beeld opbouwen',
  learnEyebrow: 'Ruimte om te leren',
  learnTitle: 'Begin met wat er nu toe doet.',
  learnBody:
    'Voeg bronmateriaal toe of verduidelijk hoe je bedrijf werkt. Poneva kan blijvende wijzigingen voorstellen die jij beoordeelt.',
  learnPrompt:
    'Welke belangrijke informatie ontbreekt er, op basis van onze bestaande bedrijfskennis, voor het werk dat we willen doen?',
  learnAction: 'Bespreken wat nuttig zou zijn',
  canvasEmptyTitle: 'Een beetje context helpt al veel.',
  canvasEmptyBody:
    'Je bedrijfsprofiel is het vertrekpunt. Voeg bronmateriaal en beoordeelde notities toe om Poneva je werk te helpen begrijpen.',
  pageEyebrow: 'Werkruimte van {company}',
  pageTitle: 'Bedrijfskennis',
  pageDescription: 'De bronnen en kennis achter het werk van Poneva.',
  tabOverview: 'Overzicht',
  tabPages: 'Pagina’s',
  tabSources: 'Bronnen',
  tabReview: 'Ter beoordeling',
  proposalApproved: 'Goedgekeurde bedrijfscontext',
  proposalDismissed: 'Afgewezen voorstel',
  proposalRemoval: 'Voorgestelde verwijdering',
  proposalCorrection: 'Voorgestelde correctie',
  proposalContext: 'Voorgestelde bedrijfscontext',
  proposalCurrent: 'Huidige kennis',
  proposalFactGone:
    'Het opgeslagen feit is niet meer beschikbaar. Vernieuw de bedrijfskennis voordat je deze verwijdering beoordeelt.',
  proposalReviewFallback: 'Beoordeel de voorgestelde bedrijfscontext.',
  proposalNotSaved: 'Nog niet opgeslagen. De oorspronkelijke bronnen blijven ongewijzigd.',
  proposalWaiting: 'Wacht op beoordeling · een publicatiebeheerder beslist in de Inbox',
  proposalSaving: 'Opslaan…',
  proposalApproveRemoval: 'Verwijdering goedkeuren',
  proposalApproveClarification: 'Verduidelijking goedkeuren',
  factLabel: 'Bedrijfsfeit',
  factEyebrow: 'Feit · Iedereen bij {company}',
  factSuggestCorrection: 'Een correctie voorstellen',
  factAskPrompt:
    'Help me deze opgeslagen bedrijfscontext te begrijpen of te verduidelijken: ‘{content}’',
  factAsk: 'Ernaar vragen',
  companyContextHeading: 'Bedrijfscontext',
  companyContextPrompt:
    'Ik wil onze bedrijfskennis verduidelijken. Help me na te gaan wat we weten en een update voor te stellen.',
  companyContextEmpty:
    'Nog geen goedgekeurde notities. Begin een gesprek over je bedrijf of voeg hieronder bronmateriaal toe.',
  refineInChat: 'Verfijnen in de chat',
  reviewPanelLabel: 'Kenniswijzigingen ter beoordeling',
  suggestedUpdatesHeading: 'Voorgestelde updates',
  suggestedUpdatesIntro:
    'Voorstellen uit je gesprekken. Jij bepaalt wat deel wordt van de blijvende kennis van je bedrijf.',
  reviewEmptyTitle: 'Er wacht niets op je beoordeling.',
  reviewEmptyBody:
    'Als Poneva een wijziging in je bedrijfskennis voorstelt, vind je die hier. Blijvende wijzigingen hebben altijd jouw goedkeuring nodig.',
  reviewEmptyPrompt:
    'Help me onze bedrijfskennis te beoordelen en stel voor wat we hierna het best kunnen verduidelijken.',
  inclusionPendingApproval: 'Wijziging in de opname in kennis ter goedkeuring verstuurd.',
  sourcesFileIncluded: 'Bestand opgenomen in het zoeken in kennis voor de huidige doelgroep.',
  sourcesAddFailed: 'Deze bron kon niet worden toegevoegd.',
  sourcesHeading: 'Het materiaal achter de antwoorden.',
  sourcesIntro:
    'Poneva doorzoekt het volledige bronmateriaal, niet alleen het overzicht. Bewaar originelen, bekijk wat klaar is en kies wat de basis vormt voor je antwoorden.',
  addSourceHeading: 'Materiaal van je bedrijf toevoegen',
  addSourceIntro:
    'Geüploade bronnen blijven privé in je Bibliotheek en worden alleen gebruikt voor je eigen antwoorden. Kies Delen wanneer je ze beschikbaar wilt maken voor collega’s.',
  uploadSource: 'Een bron uploaden',
  addSourcePrompt:
    'Help me een bedrijfsverklaring toe te voegen als gedeelde interne bron. Vraag wat ik wil vastleggen; verzin geen inhoud. Blijvende wijzigingen in de bedrijfskennis hebben nog steeds mijn goedkeuring nodig.',
  addThroughChat: 'Toevoegen via de chat',
  addingSource: 'Toevoegen…',
  addToKnowledge: 'Toevoegen aan kennis',
  uploadFormats: 'TXT, Markdown, CSV en JSON · Maximaal 5 MB per bestand',
  sourceExcluded: 'Uitgesloten van antwoorden',
  sourcePreparationFailed: 'Voorbereiding mislukt',
  sourcePreparing: 'Wordt voorbereid voor zoeken',
  sourceWaiting: 'Wacht op voorbereiding',
  sourceReadinessUnknown: 'Gereedheid niet beschikbaar',
  sourceRetryQueued:
    'Voorbereiding in de wachtrij gezet. De gereedheid wordt bijgewerkt zodra die klaar is.',
  sourceIncludedNotice: 'Bron opgenomen. Poneva bereidt hem voor op zoeken.',
  sourceExcludedNotice: 'Uitgesloten van antwoorden. De oorspronkelijke bron blijft bewaard.',
  sourceUpdateFailed: 'Deze bron kon niet worden bijgewerkt.',
  sourceOriginalMaterial: 'Oorspronkelijk bronmateriaal',
  sourceDiscuss: 'Bespreken in de chat',
  sourceDiscussPrompt: 'Help me ‘{title}’ te begrijpen of te verduidelijken.',
  sourceExclude: 'Uitsluiten van antwoorden',
  sourceInclude: 'Opnemen in antwoorden',
  sourcesLoadFailed: 'We konden je bronnen niet laden.',
  sourceLibraryLabel: 'Bronnenbibliotheek van het bedrijf',
  sourceListCaption: 'Oorspronkelijke bronnen · opgenomen en uitgesloten',
  sourceSearchLabel: 'Bedrijfsbronnen doorzoeken',
  sourceSearchPlaceholder: 'Je bronnen doorzoeken…',
  sourcesFinding: 'Je bronnen zoeken…',
  sourcePagesLabel: 'Bronpagina’s',
  sourceRange: '{from}–{to} van {count}',
  sourceCount: 'one:bron|other:bronnen',
  sourcePrevious: 'Vorige',
  sourceNext: 'Volgende',
  sourceNoMatchTitle: 'Geen overeenkomende bronnen.',
  sourceNoMatchBody: 'Probeer een andere zoekterm of bronnaam.',
  sourceEmptyTitle: 'Geef je vragen een sterker vertrekpunt.',
  sourceEmptyBody:
    'Voeg bedrijfsdocumenten, productgegevens of werknotities toe. Poneva kan het volledige bronmateriaal gebruiken in gesprekken en Skills.',
  indexCheckFailed: 'We konden de bronvoorbereiding niet controleren.',
  indexRetryQueued:
    'Mislukte kennisitems staan in de wachtrij voor voorbereiding. Je bronmateriaal is ongewijzigd.',
  indexQueueFailed: 'We konden de voorbereiding niet in de wachtrij zetten. Probeer het opnieuw.',
  indexPreparing: 'Nieuwe kennis wordt voorbereid voor je gesprekken…',
  indexAttention: 'Sommige kennis vraagt aandacht.',
  queuing: 'In wachtrij zetten…',
  retryPreparation: 'Voorbereiding opnieuw proberen',
  sourceKindStatement: 'Bedrijfsverklaring',
  sourceKindWebsite: 'Website',
  sourceKindDocument: 'Document',
  factAnswers: 'one:antwoord|other:antwoorden',
  factUsedThisWeek: 'Deze week gebruikt in {answers}',
  factLastUsed: 'laatst gebruikt: {when}',
  factToday: 'vandaag',
  factYesterday: 'gisteren',
  factImpact: 'Deze wijziging raakt een feit dat deze week in {answers} is gebruikt.',
  factCorrectionAbout: 'Over dit bedrijfsfeit: ‘{content}’ ({link})',
  factCorrectionOutdated: 'Dit is verouderd:',
  sourceCanvasRecorded: 'Vastgelegd bronmateriaal',
  sourceCanvasNotIncluded:
    'Niet opgenomen in de bedrijfskennis. Het origineel blijft bewaard als referentie en kan nog in een specifiek gesprek worden gebruikt.',
  sourceCanvasOpenOriginal: 'Oorspronkelijke bron openen',
  sourceCanvasUnavailable: 'De inhoud van de bron is niet beschikbaar.',
  sourceCanvasDiscussPrompt: 'Help me ‘{title}’ te begrijpen of te verduidelijken.',
  sourceCanvasDiscuss: 'Deze bron bespreken',
  sourceCanvasCorrectionNote:
    'Een correctie wordt voorgestelde bedrijfscontext. De vastgelegde bron blijft ongewijzigd.',
  contextCanvasEyebrow: 'Beschikbare bedrijfscontext',
  contextCanvasTitle: 'De kennis achter dit gesprek.',
  contextCanvasBody:
    'Goedgekeurde kennis en het bronmateriaal dat je bedrijf heeft toegevoegd. Beschikbaar in de chat en in Skills.',
  contextCanvasOpen: 'Kennis openen',
};

export default nl;
